/**
 * The Huewine mark, from `Huewine Technologies_FINAL_Wi_Voilet BG.svg`.
 *
 * <p>Inline rather than an `<img src="/logo.svg">`: the mark sits in the sidebar header and on the
 * sign-in panel, both of which are the first thing painted, and a logo that arrives one request
 * late is a visible flash on every load. The same artwork is in `public/logo.svg` for anything
 * outside React — a favicon, an email, an error page.
 *
 * <p>Full-bleed circle, so it needs no tile behind it. Size it with `className`.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 9064 9064"
      className={className ?? "h-8 w-8"}
      role="img"
      aria-label="Huewine"
    >
      <circle cx="4532" cy="4532" r="4532" fill="#372B66" />
      <path
        fill="#FEFEFE"
        fillRule="nonzero"
        d="M5658 1815c12,-8 63,-22 120,-24l505 -14c57,-2 99,15 124,38 25,23 41,60 41,110l0 455c0,51 -16,87 -41,110 -25,23 -67,38 -124,38l-683 0c-97,0 -129,-76 -109,-174l87 -427c11,-54 47,-92 79,-113z"
      />
      <path
        fill="#7E71B1"
        fillRule="nonzero"
        stroke="#7E71B1"
        strokeWidth={7.21489}
        d="M6448 7057c0,50 -16,87 -41,110 -25,23 -67,36 -124,38 -57,2 -141,3 -252,3 -110,0 -194,-1 -252,-3 -57,-2 -99,-15 -124,-38 -25,-23 -41,-60 -41,-110l-1 -1185 0 -119 767 -2782 4 2c7,4 13,9 19,14 25,23 41,60 41,110l3 3960z"
      />
      <path
        fill="#FEFEFE"
        fillRule="nonzero"
        d="M2936 7184l-85 0 -5 0 -476 0 -710 -2980c-12,-48 -4,-87 15,-115 19,-28 54,-64 111,-64l508 0c57,0 98,-7 128,9 29,16 54,48 64,97l407 1974 497 -2305c11,-49 35,-80 64,-97 29,-16 71,-9 128,-9l191 0 10 0 191 0c57,0 98,-8 128,9 29,16 51,49 64,97l497 1801 641 -2544c12,-48 35,-80 64,-97 29,-16 71,-9 128,-9l508 0c57,0 92,36 111,64 19,28 27,67 15,115l-945 3550 -476 0 -5 0 -85 0 -5 0 -476 0 -362 -996 -362 1501 -476 0 -5 0z"
      />
    </svg>
  );
}
